<template>
<div id="scene-container" ref="sceneContainer">
    <div id="ui-container" ref="uiContainer">
        <main>
            <h1>{{ artifact.name }}</h1>
            <p>{{ artifact.description }}</p>
            <router-link to="/explore">Explore the site to find this item in context.</router-link>
        </main>

        <div class="player">
            <div class="progress">
                <div class="credits">
                    <p>{{ artifact.audiotitle }}</p>
                    <p>{{ artifact.audioartist }}</p>
                </div>

                <div class="audio-player">
                    <AudioPlayer v-bind:audioSrc="artifact.audio" />
                </div>

                <!-- <p><a :href="collectables[iden].link" target="_blank">Item Page</a></p> -->
                <button class="close" @click="toggleModalParent">
                    <img src="/images/ui/ui_close.png" alt="Close Collection View">
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    findItemById
} from "@/store/index.js"
// import Stats from "stats.js";
import * as THREE from "three";
import GateElements from "@/components/GateElements";
import AudioPlayer from "@/components/AudioPlayer";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";


export default {
    name: "Artifact",
    components: {
        AudioPlayer
    },
    data() {
        return {
            currentPath: (Number(this.$router.currentRoute.params['id'])),
            artifactModel: null,
        }
    },
    methods: {
        async init() {
            // set container
            this.container = this.$refs.sceneContainer

            // add stats
            // this.stats = new Stats()
            // this.container.appendChild(this.stats.dom)

            // add camera
            this.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 100);
            this.camera.position.set(10, 10, 10);
            this.camera.lookAt( new THREE.Vector3( 0, 0, 0 ) );

            // create renderer
            this.renderer = GateElements.createRenderer()
            this.container.appendChild(this.renderer.domElement)

            // create scene
            this.scene = new THREE.Scene()
            this.scene.background = new THREE.Color('#EEEEEE')
            this.scene.fog = new THREE.FogExp2( 0xEEEEEE, 0.075 );

            // add lights
            const hemiLight = new THREE.HemisphereLight(0xffffff, 0x080808, 1.5);
            hemiLight.position.set(-1.25, 1, 1.25);

            const mainLight = new THREE.DirectionalLight(0xffffff, 4.0)
            mainLight.position.set(-10, 10, 10)
            this.scene.add(hemiLight, mainLight)

            // artifact geometry
            this.artifactModel = await this.loadGeometryAsync()
            this.artifactModel.scene.position.z = 0
            this.scene.add(this.artifactModel.scene);

            // // ---------------------------------------------------------------------
            // // Grid
            // // ---------------------------------------------------------------------
            // this.gridHelper = new THREE.GridHelper( 100, 20 );
            // this.gridHelper.position.y = 0;
            // this.scene.add( this.gridHelper );
            //
            // // ---------------------------------------------------------------------
            // // Axes
            // // ---------------------------------------------------------------------
            // this.scene.add( new THREE.AxesHelper( 20 ) );

        },

        render() {
            this.renderer.render(this.scene, this.camera)
            // this.stats.update()
            //rotate model
            this.artifactModel.scene.rotation.y += 0.003
        },

        animate() {
            this.renderer.setAnimationLoop(() => {
                this.render()
            })
            this.establishListeners()
        },

        establishListeners() {
            window.addEventListener('resize', this.onWindowResize.bind(this), false)

        },

        onWindowResize() {
            // set aspect ratio to match the new browser window aspect ratio
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);

        },

      // GEOMETRY async
      loadGeometryAsync() {
       let modelPath = this.artifact.model
        return new Promise((resolve) => {
          const loader = new GLTFLoader()
          loader.load(modelPath,
              model => {
                resolve(model)
              },
              undefined,
              undefined
          )
        })
      },

    },

    mounted() {
        this.init().then(() => this.animate())
    },

    computed: {
        artifact() {
            return findItemById(this.currentPath)
        },
    }
}
</script>

<style scoped>
#scene-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    z-index: 96;
}

#ui-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
}

main {
    padding: 2em .5em 6em;
    margin: 0 auto;
    max-width: 32em;
}

.player {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - (.3em * 2));
    padding: .3em;
    background-color: var(--modal-back);
    display: flex;
    justify-content: space-between;
    z-index: 5;
    border-top: 1px solid var(--darkest);
}

.progress {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.audio-player {
    flex-grow: 2;
}

.credits p {
    font-size: .65em;
    line-height: 1;
    margin: 0;
    padding-left: 1em;
}

.credits p:first-of-type {
    font-weight: bold;
}

.close {
    display: none;
}

@media screen and (min-width: 660px) {
    .credits {
        padding-right: 2em;
    }

    .credits p {
        font-size: 1em;
        line-height: 1;
        margin: 0;
    }
}
</style>
